import React from 'react'
import PropTypes from 'prop-types'

function EmailOutboxRowActions({
  draft,
  onPreview,
  onTestSend,
  onSend,
  onCancel,
  onRetry,
}) {
  return (
    <div className="btn-group btn-group-sm" role="group">
      <button
        onClick={() => onPreview(draft)}
        className="btn btn-outline-primary"
        title="Preview"
      >
        👁️
      </button>
      <button
        onClick={() => onTestSend(draft)}
        className="btn btn-outline-secondary"
        title="Test Send"
      >
        🧪
      </button>
      {draft.status === 'draft' && (
        <>
          <button
            onClick={() => onSend(draft)}
            className="btn btn-success"
            title="Send"
          >
            📧
          </button>
          <button
            onClick={() => onCancel(draft)}
            className="btn btn-danger"
            title="Delete"
          >
            🗑️
          </button>
        </>
      )}
      {draft.status === 'failed' && (
        <button
          onClick={() => onRetry(draft)}
          className="btn btn-secondary"
          title="Retry"
        >
          🔁
        </button>
      )}
    </div>
  )
}

EmailOutboxRowActions.propTypes = {
  draft: PropTypes.shape({
    id: PropTypes.number,
    status: PropTypes.string,
  }).isRequired,
  onPreview: PropTypes.func.isRequired,
  onTestSend: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
}

export default EmailOutboxRowActions
